import { Button, Container, Typography } from "@material-ui/core";
import { postReport } from "api/platform";
import { View } from "features/global/reducer";
import React from "react";
import { connect } from "react-redux";
import { RootState } from "./rootReducer";
import i18n from "./i18n";

// prop types
type ErrorBoundaryProps = {
    children?: React.ReactNode,
    view?: View,
};

// state types
interface ErrorBoundaryState {
    hasError: boolean,
}

// initial state
const initialState = {
    hasError: false,
};

// error boundary
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = initialState;
    }

    componentDidCatch(error: any, errorInfo: any) {
        const { view } = this.props;
        const description = JSON.stringify({ error: error.toString(), errorInfo });
        if (window.location.hostname !== "localhost") {
            postReport({
                context: view || "unknown",
                description,
            });
        }
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        // error
        if (hasError) {
            return (
                <Container maxWidth="md" style={{ marginTop: "32px", textAlign: "center" }}>
                    <img src="images/playsports_logo.svg" alt="PLAYSPORTS" style={{ height: "96px", margin: "32px" }} />
                    <Typography variant="h6">{i18n.somethingWentWrong}</Typography>
                    <Button
                        color="primary"
                        style={{ marginTop: "32px" }}
                        variant="contained"
                        onClick={() => { window.location.href = "/"; }}
                    >
                        {i18n.reload}
                    </Button>
                </Container>
            );
        }

        // no error
        return children;
    }
}

// redux
const mapStateToProps = (state: RootState) => ({
    view: state.global.view,
});

const connector = connect(mapStateToProps, null);
export default connector(ErrorBoundary);
